// extracted by mini-css-extract-plugin
export var container = "instagram-card-module--container--9EA3n";
export var imageBox = "instagram-card-module--image-box--Jb9M6";
export var ratio = "instagram-card-module--ratio--twBo9";